﻿import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef, Input, OnChanges, SimpleChanges } from '@angular/core';

import { leaderboardApi } from '../../../config/api-url';
import { Errors, LeaderboardService } from '../../../core';
import { FileService } from '../../../core/services/file.service';

@Component({
  selector: 'app-leaderboard-cisco-tab',
  templateUrl: './leaderboard-cisco-tab.component.html',
  styleUrls: ['./leaderboard-cisco-tab.component.scss']
})
export class LeaderboardCiscoTabComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() userData: any;
  @Input() pamData: any = '';
  @Input() isActive: boolean = false;

  @ViewChild('rankTemplate') rankTemplate!: TemplateRef<any>;
  @ViewChild('participantTemplate') participantTemplate!: TemplateRef<any>;
  @ViewChild('bookingsTemplate') bookingsTemplate!: TemplateRef<any>;
  @ViewChild('earningsTemplate') earningsTemplate!: TemplateRef<any>;

  errors: Errors = { errors: {} };
  fiscalDropDownList: any = [];
  selectedFiscal: any;
  selectedTopCiscoBooking: any;
  topCiscoBookingsColumns: any[] = [];
  topCiscoBookingsPage: number = 1;
  topCiscoBookingsItemsPerPage: number = 5;

  isLoading: boolean = false;
  private hasLoaded: boolean = false;

  constructor(
    private leaderboardService: LeaderboardService,
    private fileService: FileService,
  ) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isActive'] && this.isActive && !this.hasLoaded) {
      this.hasLoaded = true;
      this.getFiscalDropDownList();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => { this.initializeTopCiscoBookingsTable(); });
  }

  getFiscalDropDownList() {
    this.leaderboardService.getFiscalDropDownList().subscribe((data) => {
      if (data.length) {
        this.fiscalDropDownList = data;
        this.selectedFiscal = this.fiscalDropDownList[0];
        this.getTopCiscoBookings();
      }
    }, (err) => {
      this.errors = err;
    });
  }

  onFiscalChange(selectedFiscal: any) {
    this.selectedFiscal = selectedFiscal;
    this.getTopCiscoBookings();
  }

  getTopCiscoBookings(): void {
    const beGeoId = this.pamData === ''
      ? this.userData.company.beGeoId
      : this.pamData.pamBeGeoIdsDTO.beGeoIds.content[0].beGeoId;

    const queryParams: any = {
      beGeoIds: beGeoId,
      fiscalYear: this.selectedFiscal.fiscalYear,
      page: 0,
      size: 5,
      excel: false,
      period: this.selectedFiscal.name
    };

    if (this.selectedFiscal.fiscalQuarter !== null) {
      queryParams.fiscalQuarter = this.selectedFiscal.fiscalQuarter;
    }

    this.topCiscoBookingsPage = 1;
    this.fetchTopCiscoBookingsData(queryParams);
  }

  fetchTopCiscoBookingsData(queryParams: any): void {
    this.isLoading = true;
    this.leaderboardService.getTopCiscoBookings(queryParams).subscribe(
      (res) => {
        this.isLoading = false;
        if (res) {
          let formattedData: any;
          if (Array.isArray(res)) {
            formattedData = { content: res, totalElements: res.length };
          } else if (res && res.content) {
            formattedData = res;
          } else {
            formattedData = { content: res || [], totalElements: res ? 1 : 0 };
          }

          this.selectedTopCiscoBooking = {
            sellerTab: 'STP',
            data: formattedData,
            qtr: queryParams.fiscalQuarter || this.selectedFiscal.fiscalQuarter,
            year: queryParams.fiscalYear || this.selectedFiscal.fiscalYear,
            period: queryParams.period || this.selectedFiscal.name,
            queryParams: queryParams
          };
          this.initializeTopCiscoBookingsTable();
        }
      },
      (err) => {
        this.isLoading = false;
        this.errors = err;
      }
    );
  }

  initializeTopCiscoBookingsTable() {
    const rankCol: any = { field: 'sellerRanking', header: 'Rank', align: 'center', isBold: true };
    const participantCol: any = { field: 'sellerName', header: 'Participant' };
    const bookingsCol: any = { field: 'totalBookings', header: 'Bookings', align: 'right', isBold: true, prefix: '$' };
    const earningsCol: any = { field: 'totalEarnings', header: 'Earnings', align: 'right', highlight: 'green', isBold: true };

    if (this.rankTemplate) { rankCol.cellTemplate = this.rankTemplate; }
    if (this.participantTemplate) { participantCol.cellTemplate = this.participantTemplate; }
    if (this.bookingsTemplate) { bookingsCol.cellTemplate = this.bookingsTemplate; }
    if (this.earningsTemplate) { earningsCol.cellTemplate = this.earningsTemplate; }

    this.topCiscoBookingsColumns = [
      rankCol,
      { field: 'country', header: 'Country' },
      participantCol,
      bookingsCol,
      earningsCol
    ];
  }

  onTopCiscoBookingsPageChange(newPage: number) {
    this.topCiscoBookingsPage = newPage;
    const updatedParams = { ...this.selectedTopCiscoBooking.queryParams, page: newPage - 1 };
    this.fetchTopCiscoBookingsData(updatedParams);
  }

  downloadClaimByExcel() {
    const fileName = 'Partners_LeaderboardData _Export_' + this.userData.company.id + '.xlsx';
    const qatar = this.selectedFiscal.fiscalQuarter == null ? '' : this.selectedFiscal.fiscalQuarter;
    let param: string;
    if (this.userData.userType === 'PAM') {
      param = '?beGeoIds=' + this.pamData.pamBeGeoIdsDTO.beGeoIds.content[0].beGeoId + '&fiscalQuarter=' + qatar + '&period=' + this.selectedFiscal.name + '&excel=true';
    } else {
      param = '?beGeoIds=' + this.userData.company.beGeoId + '&fiscalQuarter=' + qatar + '&period=' + this.selectedFiscal.name + '&excel=true';
    }
    const excelURL = leaderboardApi.sellerTotalPerformanceExport.replace('{param}', param);
    this.fileService.excelDownloadFile(excelURL, fileName);
  }

  splitData(value: any): string {
    const parseValue = parseFloat(value);
    if (isNaN(parseValue)) { return '0'; }
    return parseValue.toLocaleString('en-US');
  }
}
